import { TailSpin, ThreeDots } from "react-loader-spinner";
import Footer from "../../components/Footer";
import Pagination from "../../components/Pagination";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Cookies from "js-cookie";
import { formatLeaveType, toggleMenu } from "../../utils/helpers";
import { getApi } from "../../utils/api";
import { API_LEAVE_TODAY, GET_EMPLOYEE_LIST } from "../../config/Endpoints";
import Select, { components } from "react-select";
import TruncateText from "../../components/TruncateText";
import CommonDatePicker from "../../components/CommonDatePicker";
import PageTitle from "../../components/PageTitle";
import { displayFormatDate } from "../../utils/helpers";
import SortableTable from "../../components/SortableTable";

const OnLeaveToday = ({ title, description }) => {
  const [leaveList, setLeaveList] = useState([]);
  const [searchDate, setSearchDate] = useState(
    new Date().toISOString().slice(0, 10)
  );
  const [isLoading, setIsLoading] = useState(false);
  const [filteredItems, setFilteredItems] = useState([]);
  const accessToken = Cookies.get("accessToken");
  const [employeeList, setEmployeeList] = useState([]);
  const [selectedEmployee, setSelectedEmployee] = useState("");
  const [tableData, setTableData] = useState([]);

  const [sortConfig, setSortConfig] = useState({
    key: null,
    direction: "",
  });

  const columns = [
    { key: "name", label: "Employee Name" },
    {
      key: "creationDate",
      label: "Requested Date",
      compare: (a, b) =>
        new Date(a._original.creationDate) - new Date(b._original.creationDate),
    },
    { key: "startDate", label: "From" },
    { key: "endDate", label: "To" },
    { key: "typeOfLeave", label: "Type" },
    { key: "noOfDays", label: "Leave Count" },
    { key: "reasonOfLeave", label: "Reason", sortable: false },
  ];

  useEffect(() => {
    setTableData(
      filteredItems.map((item) => ({
        name: item.name,
        creationDate: displayFormatDate(item.creationDate),
        startDate: displayFormatDate(item.startDate),
        endDate: displayFormatDate(item.endDate),
        typeOfLeave: formatLeaveType(item.typeOfLeave),
        noOfDays: item.noOfDays,
        reasonOfLeave: <TruncateText text={item.reasonOfLeave || "-"} />,
        _original: item,
      }))
    );
  }, [filteredItems]);

  useEffect(() => {
    fetchList();
  }, [selectedEmployee, searchDate]);

  useEffect(() => {
    fetchListEmployee();
  }, []);

  const fetchListEmployee = () => {
    setIsLoading(true);
    getApi(GET_EMPLOYEE_LIST, accessToken)
      .then((res) => {
        if (res.status === 200) {
          setEmployeeList(res.data.data);
          setIsLoading(false);
        }
      })
      .catch((e) => {
        console.log(e);
        setIsLoading(false);
      });
  };

  const fetchList = () => {
    setIsLoading(true);
    getApi(
      API_LEAVE_TODAY +
        `?date=${searchDate}&empid=${
          selectedEmployee && selectedEmployee?.value
        }`,
      accessToken
    )
      .then((res) => {
        if (res.status === 200) {
          setLeaveList(res.data?.data ? res.data?.data : []);
          setFilteredItems(res.data?.data ? res.data?.data : []);
        }
        setIsLoading(false);
      })
      .catch((e) => {
        console.log(e);
        setIsLoading(false);
      });
  };
  return (
    <div className="wrapper-body">
      {/* Page Heading */}
      <div className="page-heading">
        <div id="showMenuBtn" className="collapse-button" onClick={toggleMenu}>
          <span></span>
          <span></span>
          <span></span>
        </div>
        <PageTitle title={title} description={description} />
        <div className="total">
          Total Leaves : <span>{filteredItems?.length}</span>
        </div>
      </div>
      {/* Filters */}
      <div className="filters">
        {/* Search By Company */}
        <div className="search">
          {/* <input
            type="date"
            name="search"
            value={searchDate}
            onChange={(e) => setSearchDate(e.target.value)}
            onKeyPress={(e) => {
              if (e.charCode === 32 && e.target.selectionStart === 0) {
                e.preventDefault(); // Prevent adding space at the beginning
              }
            }}
          /> */}
          <CommonDatePicker
            // minDate={getMinDate()}
            // maxDate={today}
            selectedDate={searchDate}
            setSelectedDate={setSearchDate}
          />
        </div>
        {/*
        <div className="search">
          <Select
            options={optionList}
            components={{ Option }}
            onChange={(option) => {
              setSelectedEmployee(option);
            }}
            value={selectedEmployee}
            placeholder="Select employee"
            isSearchable={true}
            isDisabled={employeeList?.length === 0}
            isRequired={true}
            styles={{
              container: (provided) => ({ ...provided, width: "100%" }),
            }}
          />
        </div>
        */}
      </div>

      {/* Data Table */}
      {!isLoading && tableData.length > 0 && (
        <SortableTable columns={columns} data={tableData} />
      )}
      {!isLoading && filteredItems?.length === 0 && (
        <div className="fs-4 text-secondary text-center">
          No Record Available
        </div>
      )}
      {isLoading && (
        <div className="centered-loader">
          <ThreeDots
            height="100"
            width="100"
            radius="9"
            color="blue"
            ariaLabel="three-dots-loading"
            wrapperStyle={{}}
            wrapperClassName=""
            visible={true}
          />
        </div>
      )}

      {/* Footer */}
      <Footer />
    </div>
  );
};

export default OnLeaveToday;
